module.exports = __webpack_public_path__ + "static/media/lisboa.10b89d28.jpg";